import { useQuery, gql } from '@apollo/client'
import { format } from 'date-fns'
import { DATETIME } from 'constants/datetime'

const EXPERT_REVENUES_QUERY = gql`
  query expertRevenueQuery($id: Int!, $expertChartsInput: ExpertChartOptions!) {
    expertMe(id: $id) {
      id
      charts {
        sessionRevenue(input: $expertChartsInput) {
          date {
            isoFormat
          }
          unix
          chartData {
            status
            value
            currencyIsoCode
          }
        }
      }
    }
  }
`

export const useExpertRevenuesQuery = ({
  expertId: id,
  period: { date, groupBy: groupType } = {},
}) => {
  const { loading: isLoading, data: expertRevenuesData } = useQuery(
    EXPERT_REVENUES_QUERY,
    {
      variables: {
        id,
        expertChartsInput: {
          date: {
            from: format(date.from, DATETIME),
            to: format(date.to, DATETIME),
          },
          groupType,
        },
      },
    }
  )

  const revenue = expertRevenuesData
    ? expertRevenuesData.expertMe.charts.sessionRevenue
    : []

  return { isLoading, data: revenue }
}
